import { useMsg } from '~/common/localizationUtils'

/**
 * Utility hook to get the first `limit` recipients from `recipients` and formats
 * any additional recipients as a count
 *
 * @param recipients list of recipients to share with
 * @param limit the number of recipients to display before truncating
 * @returns the first `limit`recipients and the count of the remaining
 * @example
 * const condenseRecipients = useCondenseRecipients()
 * const recipients = ['Bob', 'Sally', 'Charlie', 'Greg']
 * condenceRecipients(recipients, 2) // -> 'Bob, Sally, and 2 others'
 */
export const useCondenseRecipients = () => {
  const msg = useMsg()

  const condenseRecipients = (recipients: Array<string>, limit = 1) => {
    const slicedUp = recipients.slice(0, limit).join(', ')
    return recipients.length > limit
      ? `${slicedUp} ${msg('custom_report.shared_with_count', { count: recipients.length - limit })}`
      : slicedUp
  }

  return condenseRecipients
}
